import React from 'react';
import PageShell from '../../components/PageShell';
import ProjectDetailsMain from './ProjectDetailsMain';
import ProjectsMain from './ProjectsMain';

export const Projects = () => (
  <PageShell>
    <ProjectsMain />
  </PageShell>
);

export const ProjectDetails = () => (
  <PageShell>
    <ProjectDetailsMain />
  </PageShell>
);
